// permissions.js
export const PermissionBits = {
  0: "NONE",
  1: "VIEW",
  2: "UNLOCK",
  4: "TABLEVIEW",
  8: "REPORTS",
  16: "PRINT",
  32: "LOCK",
  64: "FIND",
  128: "ADD",
  256: "MODIFY",
  512: "DELETE",
  1023: "ALL",
};

export const Permissions = {
  NONE: 0,
  VIEW: 1,
  UNLOCK: 2,
  TABLEVIEW: 4,
  REPORTS: 8,
  PRINT: 16,
  LOCK: 32,
  FIND: 64,
  ADD: 128,
  MODIFY: 256,
  DELETE: 512,
  ALL: 1023,
};

export const Security_Types = {
  criteria: "Criteria",
  functionality: "Functionality",
  record: "Record",
  clientParams: "clientParameter",
};

export const Entity_types = {
  arbitary: "Arbitrary",
  module: "Module",
  subModule: "SubModule",
  field: "field",
};
